import styled from 'styled-components';

export const StyledSEOLink = styled.a`
    visibility: hidden;
`;

export const StyledSeoLinksContainer = styled.div`
    display: none;
`;
